import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { TextValueItem } from "@/models/TextValueItem";
import api from "@/services/api";
import permessi from "@/config/permessi";
import { ContraentiItem } from "@/models/amministrazione/contraenti/contraenti";

const _ENDPONT = api.endpoint.AMMINISTRAZIONE.CONTRAENTI;
@Component({})
export default class Contraenti extends gridComponentBase {
	get PERMESSI(): string[] {
		return [permessi.BK.Amministrazione.CONTRAENTI];
	}
	editItem: ContraentiItem = new ContraentiItem();
	showEditModal: boolean = false;
	editSubTitle: string = "";
	editTitle: string = "";
	kendop: any = kendo;

	showOnlyActive: boolean = false;

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, headerCell: "myHeaderCellTemplate", editHide: true },
			{
				field: "contraente",
				title: this.$i18n.t("generico.contraente").toString(),
				width:  this.setColPercent(15),
				headerCell: "myHeaderCellTemplate"
			},
			{
				field: "templateEmailCopertura",
				title: this.$i18n.t("generico.templateEmailCopertura").toString(),
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				export: true,
				width: this.setColPercent(10)
			},

			{
				field: "includiSuEC",
				title: this.$i18n.t("generico.includiSuEC").toString(),
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				export: true,
				width:  this.setColPercent(10),
				filterType: "boolean",
				editType: "boolean",
				type: "boolean",
				disabled: true
			},
			{
				field: "disabilitaUtilizzoCredito",
				title: this.$i18n.t("generico.disabilitaUtilizzoCredito").toString(),
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				export: true,
				width:  this.setColPercent(6),
				filterType: "boolean",
				editType: "boolean",
				type: "boolean",
				disabled: true
			},
			{
				field: "raggruppamentoRiepilogoFatturati",
				title: this.$i18n.t("generico.raggruppamentoRiepilogoFatturati").toString(),
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				export: true,
				width:  this.setColPercent(10),
				filterType: "numeric-int",
				editType: "numeric-int",
			},
			{
				field: "ragioneSociale",
				title: this.$i18n.t("generico.ragioneSociale").toString(),
				headerCell: "myHeaderCellTemplate"
			},
			{
				field: "partitaIva",
				title: this.$i18n.t("generico.partitaIva").toString(),
				headerCell: "myHeaderCellTemplate"
			},
			{
				field: "indirizzo",
				title: this.$i18n.t("generico.indirizzo").toString(),
				headerCell: "myHeaderCellTemplate"
			},
			{
				field: "citta",
				title: this.$i18n.t("generico.citta").toString(),
				headerCell: "myHeaderCellTemplate"
			},
			{
				field: "cap",
				title: this.$i18n.t("generico.cap").toString(),
				headerCell: "myHeaderCellTemplate"
			},
			{
				field: "provincia",
				title: this.$i18n.t("generico.provincia").toString(),
				headerCell: "myHeaderCellTemplate",
				width:  this.setColPercent(6)
			},

			{ field: "_actions", title: " ", width: 50 + (this.canDelete ? 50 : 0), cell: "defaultCellTemplate", type: "actions_list", filterable: false, headerCell: "myHeaderCellTemplate" }
		];
	}

	created() {
		var self = this;
		//this.take = 60;
		//this.pageable.pageSize = 60;
		//this.pageSize = 60;
		if (this.group) {
			this.group.map(group => (group.aggregates = this.aggregates));
		}
		this.group = this.group;

		this.refreshGrid();
	}

	refreshGrid(){
		var self = this;
		Promise.all([])
		.then(responses => {
			self.getData();
		})
		.catch(err => {
			console.log(err);
		});
	}

	getData() {
		this.getGridData(`${_ENDPONT}`);
	}

	onDelete(item: any) {
		var self = this;
		var message = self.$createElement("div", { domProps: { innerHTML: `<h5>${item.contraente}</h5>${self.$i18n.t("messaggio.confermaCancellazione")}` } }); // h('div', { domProps: { innerHTML: 'Title from <i>HTML<i> string' } })
		var title = this.$i18n.t("titolo.elimina", [this.$i18n.t("generico.contraente")]).toString();
		self.deleteGridRow(_ENDPONT, item.itemID, title, [message]);
	}

	addNewRow() {
		let newItem = new ContraentiItem();

		this.onEdit(newItem);
	}

	onEdit(item: any) {
		var self = this;
		self.editItem = Object.assign(new ContraentiItem(), item);
		self.editSubTitle = "";
		self.editTitle = item.itemID;
		self.showEditModal = true;
	}

	onSaveEdit() {
		var self = this;
		var title = this.$i18n.t("msg.salvataggioRiuscito").toString();
		var message = this.$i18n.tc("msg.salvato_iCorrettamente", 1, { obj: this.$i18n.t("generico.contraente") }).toString();
		self.setGridRow<ContraentiItem>(_ENDPONT, self.editItem, title, message, self.isNewItem).then(res => {
			self.showEditModal = false;
		});
	}

	get isNewItem(): boolean {
		return (this.editItem || {}).itemID == null || (this.editItem || {}).itemID <= 0;
	}
}
